/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Seating_Move_HereInputs */



/**
* | output |
* | --- |
* | "Move here" |
*
* @param {Rounds_Seating_Move_HereInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_move_here = /** @type {((inputs?: Rounds_Seating_Move_HereInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_Move_HereInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déplacer ici")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover aquí")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mover aqui")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta qui")
	return /** @type {LocalizedString} */ ("Move here")
});